type MaybeWallet = {
  type?: string;
  walletClientType?: string;
  address?: string;
};

const EMBEDDED_WALLET_CLIENTS = new Set(['privy', 'privy-v2']);

function isExternalWallet(wallet?: MaybeWallet | null): boolean {
  if (!wallet) return false;
  return !EMBEDDED_WALLET_CLIENTS.has((wallet.walletClientType || '').toLowerCase());
}

export function getPreferredEoaWallet<T extends MaybeWallet>(wallets?: T[] | null): T | null {
  if (!wallets || wallets.length === 0) return null;

  const ethereumWallets = wallets.filter((wallet) => wallet?.type === 'ethereum');
  const externalEthereumWallet = ethereumWallets.find((wallet) => isExternalWallet(wallet));

  if (externalEthereumWallet) return externalEthereumWallet;
  if (ethereumWallets.length > 0) return ethereumWallets[0];

  const firstExternalWallet = wallets.find((wallet) => isExternalWallet(wallet));
  return firstExternalWallet ?? wallets[0] ?? null;
}

export function getPreferredWalletAddress(wallets?: MaybeWallet[] | null): string | undefined {
  return getPreferredEoaWallet(wallets)?.address;
}
